import { useEffect, useState } from 'react';

const QUERY = '(pointer: coarse)';

/**
 * True on touch-primary devices (phones/tablets) where the OS drives momentum
 * scrolling — programmatic scroll clamping fights that physics and reads as
 * bounce/jitter, so touch-only behavior should skip it.
 */
export function useCoarsePointer(): boolean {
  const [coarse, setCoarse] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return;
    const mq = window.matchMedia(QUERY);
    const update = () => setCoarse(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);

  return coarse;
}
